import { CSSResultArray, unsafeCSS } from 'lit';
import { customElement } from 'lit/decorators.js';
import { BeaconLineChart } from '@trp-beacon-ui-kit/foundation/components/beacon-line-chart';
import style from './product-center-line-chart.scss?inline';
import { Constants } from './product-center-line-chart.constants';

/**
 * @tag pop-product-center-line-chart
 */
@customElement(Constants.TAG_NAME)
export class PopProductCenterLineChart extends BeaconLineChart {
  static get styles(): CSSResultArray {
    const parentStyles = super.styles;
    // Return the combined styles
    return [parentStyles, unsafeCSS(style)];
  }
}
